import * as React from 'react';
import Layout from '../../components/Utilities/Layout';
import { Box, Button, Card, CardContent, Grid, Stack, Typography } from '@mui/material';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import Groups2OutlinedIcon from '@mui/icons-material/Groups2Outlined';
import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined';
import GppGoodOutlinedIcon from '@mui/icons-material/GppGoodOutlined';
import SecurityTrimmer from '../../components/Utilities/SecurityTrimmer';
import { Entity, PermissionLevel } from '../../utilities/Permisos';
import EntityPermissions from '../../components/EntityPermissions';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import MarkunreadMailboxOutlinedIcon from '@mui/icons-material/MarkunreadMailboxOutlined';
import StorageOutlinedIcon from '@mui/icons-material/StorageOutlined';
import IpsAssignedChart from './IpsAssignedChart';
import IpsByCpChart from './IpsByCpChart';
import ReactInterval from 'react-interval';
import Common from '../../utilities/common';
import IpsByProvinciaChart from './IpsByProvinciaChart';
import IpsByComunidadAutomonaChart from './IpsByComunidadAutomonaChart';
import TotalChart from '../../Chart/TotalChart';
import $ from "jquery";

export interface IIPsHomeState {
    totalIps: number;
}

export default class IpsHome extends React.Component<{}, IIPsHomeState> {
    public constructor(props: {}) {
        super(props);

        this.state = {
            totalIps: 0
        }
    }

    componentDidMount(): void {
        this.GetTotal();
    }

    public render(): React.ReactElement<{}> {
        return (
            <SecurityTrimmer entity={Entity.IPS} permission={PermissionLevel.SuperAdministrar} noAccessMessage='No tiene permisos para ver este contenido.'>
                <Layout breadcrumb={
                    [
                        {
                            title: 'Inicio',
                            url: '/'
                        },
                        {
                            title: 'Configuración',
                            url: '/settings'
                        },
                        {
                            title: 'IPS',
                            url: ''
                        }
                    ]
                }>
                    <Box className='stepper'>
                        <Grid container>
                            <Grid item xs={1}>
                                <Typography>
                                    <LanguageOutlinedIcon className='mainIcon'/>
                                </Typography>
                            </Grid>
                            <Grid item xs={9}>
                                <Typography className='mainTitle'>
                                IPS
                                </Typography>
                            </Grid>
                            <SecurityTrimmer entity={Entity.IPS} permission={PermissionLevel.SuperAdministrar}>
                                <Grid item xs={2} className='entitySettings'>
                                    <EntityPermissions entity={Entity.IPS}/>
                                </Grid>
                            </SecurityTrimmer>
                        </Grid>
                    </Box>
                    <Box className='main transparent'>
                        <Grid container spacing={3}>
                            <Grid item xs={4}>
                                <Card>
                                    <CardContent>
                                        <Stack direction='row' spacing={3} style={{marginBottom: '20px'}}>
                                            <LanguageOutlinedIcon style={{fontSize: '42px'}}/>
                                            <Typography variant='h6' gutterBottom textAlign='center' fontWeight={'bold'} style={{position: 'relative', top: '5px'}}>
                                                IPS
                                            </Typography>
                                        </Stack>
                                        <Typography gutterBottom variant="body2" color='text.secondary'>
                                            Consulte el estado de asignación de IPs
                                        </Typography>
                                        <div style={{textAlign: 'right', marginTop: '20px'}}>
                                            <Button variant='contained' color='info' onClick={() => {
                                                window.location.href = '/settings/ips/data';
                                            }}>
                                                Ir
                                            </Button>
                                        </div>
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs={4}>
                                <Card>
                                    <CardContent>
                                        <Stack direction='row' spacing={3} style={{marginBottom: '20px'}}>
                                            <MarkunreadMailboxOutlinedIcon style={{fontSize: '42px'}}/>
                                            <Typography variant='h6' gutterBottom textAlign='center' fontWeight={'bold'} style={{position: 'relative', top: '5px'}}>
                                                Códigos postales
                                            </Typography>
                                        </Stack>
                                        <Typography gutterBottom variant="body2" color='text.secondary'>
                                            Inicie la asignación de códigos postales por IP
                                        </Typography>
                                        <div style={{textAlign: 'right', marginTop: '20px'}}>
                                            <Button variant='contained' color='info' onClick={() => {
                                                window.location.href = '/settings/ips/codigospostales';
                                            }}>
                                                Ir
                                            </Button>
                                        </div>
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs={4}>
                                <Card>
                                    <CardContent>
                                        <Stack direction='row' spacing={3} style={{marginBottom: '20px'}}>
                                            <StorageOutlinedIcon style={{fontSize: '42px'}}/>
                                            <Typography variant='h6' gutterBottom textAlign='center' fontWeight={'bold'} style={{position: 'relative', top: '5px'}}>
                                                Asignación de IP
                                            </Typography>
                                        </Stack>
                                        <Typography gutterBottom variant="body2" color='text.secondary'>
                                            Inicie la asignación de IPs a cada registro de la base de datos
                                        </Typography>
                                        <div style={{textAlign: 'right', marginTop: '20px'}}>
                                            <Button variant='contained' color='info' onClick={() => {
                                                window.location.href = '/settings/ips/progress';
                                            }}>
                                                Ir
                                            </Button>
                                        </div>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box className='main transparent'>
                        <Grid container spacing={3}>
                            <Grid item xs={8}>
                                <IpsByProvinciaChart />
                            </Grid>
                            <Grid item xs={4}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <TotalChart total={this.state.totalIps} title='Total IPs' icon={<LanguageOutlinedIcon style={{fontSize: '42px', position: 'relative', top: '7px', opacity: '.5'}}/>}/>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <IpsByComunidadAutomonaChart/>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                </Layout>
            </SecurityTrimmer>
        )
    }

    private GetTotal() {
        let url = `${Common.END_POINT}/masters/ip/total`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    totalIps: response[0].total
                }
            );
        })
    }
}